import * as React from 'react';
import { useParams } from 'react-router-dom';
import {
  Display,
  IsAllowed,
  List,
  NavIconContainer,
  PageTitle,
  QueryMulti,
  QuerySingle,
  Section,
  useCacheRecord,
} from 'gossamer-front-end';
import { InstitutionMemberInvite, OutboundEmail } from 'cb-model';
import { MemberInviteDeleteButton } from './MemberInviteDeleteButton';
import { getFilter } from 'gossamer-unified';

export const MemberInviteDisplay = (): React.JSX.Element => {
  const params = useParams();
  const record = useCacheRecord(InstitutionMemberInvite, params.key);
  return (
    <>
      <NavIconContainer entityId={InstitutionMemberInvite.id} />
      <PageTitle
        verb="Display"
        entity={InstitutionMemberInvite}
        keyValue={params.key}
        subtitle={
          record.data?.is_admin
            ? 'Details relating to someone invited to become an admin'
            : 'Details relating to someone invited to become a member'
        }
      />

      <Section>
        <QuerySingle entity={InstitutionMemberInvite} keyValue={params.key} render={Display} />
        <MemberInviteDeleteButton institution_member_invite_id={params.key} />
      </Section>

      <IsAllowed entity={OutboundEmail} action="read">
        <Section title="Outbound Emails">
          {!!record.data && (
            <QueryMulti
              entity={OutboundEmail}
              alterEntity={(localEntity: typeof OutboundEmail) => {
                localEntity.fields.to_email_address.listColumn = false;
                localEntity.fields.to_user_id.listColumn = false;
              }}
              queryOptions={{
                where: {
                  and: [getFilter('to_email_address', 'eq', record.data.invitee_email)],
                },
              }}
              render={List}
            />
          )}
        </Section>
      </IsAllowed>
    </>
  );
};
